import { useState } from "react";
import { gonderimData, GonderimDurumu } from "@/mocks/takip";

const DURUM_STYLE: Record<GonderimDurumu, string> = {
  "Bekliyor": "bg-amber-100 text-amber-700",
  "Gönderildi": "bg-emerald-100 text-emerald-700",
  "Hatalı": "bg-red-100 text-red-600",
  "Atlandı": "bg-gray-100 text-gray-500",
  "Durduruldu": "bg-orange-100 text-orange-700",
};
const DURUM_ICON: Record<GonderimDurumu, string> = {
  "Bekliyor": "ri-time-line",
  "Gönderildi": "ri-checkbox-circle-line",
  "Hatalı": "ri-error-warning-line",
  "Atlandı": "ri-skip-forward-line",
  "Durduruldu": "ri-stop-circle-line",
};

const DURUM_LIST: GonderimDurumu[] = ["Bekliyor", "Gönderildi", "Hatalı", "Atlandı", "Durduruldu"];
const TUR_LIST = ["Tümü", "Referans İsteme", "Ödeme Hatırlatma", "Ödeme Gecikme", "Taahhüt Bilgilendirme", "Yeni Kayıt"];

export default function GonderimPage() {
  const [search, setSearch] = useState("");
  const [durumFilter, setDurumFilter] = useState<GonderimDurumu | "Tümü">("Tümü");
  const [turFilter, setTurFilter] = useState("Tümü");

  const toplamBekleyen = gonderimData.filter(g => g.durum === "Bekliyor").length;
  const toplamGonderilen = gonderimData.filter(g => g.durum === "Gönderildi").length;
  const toplamHatali = gonderimData.filter(g => g.durum === "Hatalı").length;
  const sonGonderilen = gonderimData.filter(g => g.durum === "Gönderildi").sort((a, b) => b.gonderimZamani.localeCompare(a.gonderimZamani))[0];
  const siradaki = gonderimData.find(g => g.durum === "Bekliyor");

  const filtered = gonderimData.filter(g => {
    const s = search.toLowerCase();
    const matchSearch = !s || g.veliAdi.toLowerCase().includes(s) || g.ogrenciAdi.toLowerCase().includes(s) || g.telefon.includes(s);
    const matchDurum = durumFilter === "Tümü" || g.durum === durumFilter;
    const matchTur = turFilter === "Tümü" || g.mesajTuru === turFilter;
    return matchSearch && matchDurum && matchTur;
  });

  return (
    <div className="p-4 md:p-6 xl:p-8 space-y-6 max-w-[1600px]">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h2 className="text-xl font-bold text-gray-900">Gönderim Takibi</h2>
          <p className="text-sm text-gray-500 mt-0.5">Tüm WhatsApp gönderimlerini detaylı olarak takip edin</p>
        </div>
      </div>

      {/* Live progress section */}
      <div className="bg-[#0B1120] rounded-2xl p-5">
        <div className="flex items-center gap-2 mb-4">
          <span className="w-2 h-2 rounded-full bg-[#25D366] animate-pulse"></span>
          <p className="text-white font-semibold text-sm">Canlı Gönderim Durumu</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { label: "Sıradaki Gönderim", value: siradaki ? `${siradaki.veliAdi} (${siradaki.mesajTuru})` : "—", icon: "ri-time-line", color: "text-amber-400" },
            { label: "Son Gönderilen", value: sonGonderilen ? `${sonGonderilen.veliAdi} – ${sonGonderilen.gonderimZamani.split(" ")[1]}` : "—", icon: "ri-checkbox-circle-line", color: "text-[#25D366]" },
            { label: "Bekleyen Mesaj", value: toplamBekleyen, icon: "ri-loader-4-line", color: "text-sky-400" },
            { label: "Gönderim Aralığı", value: "~6 dakika", icon: "ri-timer-line", color: "text-gray-300" },
          ].map(s => (
            <div key={s.label} className="bg-white/5 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${s.icon} text-sm ${s.color}`}></i>
                </div>
                <p className="text-gray-400 text-[11px]">{s.label}</p>
              </div>
              <p className={`text-sm font-bold ${s.color} truncate`}>{s.value}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {[
          { label: "Toplam Kayıt", value: gonderimData.length, icon: "ri-list-check", color: "bg-[#0B1120] text-white" },
          { label: "Gönderildi", value: toplamGonderilen, icon: "ri-checkbox-circle-line", color: "bg-emerald-500 text-white" },
          { label: "Bekliyor", value: toplamBekleyen, icon: "ri-time-line", color: "bg-amber-500 text-white" },
          { label: "Hatalı", value: toplamHatali, icon: "ri-error-warning-line", color: "bg-red-500 text-white" },
          { label: "Atlandı / Durduruldu", value: gonderimData.filter(g => g.durum === "Atlandı" || g.durum === "Durduruldu").length, icon: "ri-skip-forward-line", color: "bg-gray-400 text-white" },
        ].map(s => (
          <div key={s.label} className="bg-white rounded-2xl border border-gray-100 p-4 flex items-center gap-3">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${s.color}`}>
              <i className={`${s.icon} text-base`}></i>
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">{s.value}</p>
              <p className="text-[11px] text-gray-500 leading-tight">{s.label}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Table */}
      <div className="bg-white rounded-2xl border border-gray-100">
        <div className="p-4 border-b border-gray-100 flex flex-col lg:flex-row gap-3">
          {/* Durum filter */}
          <div className="flex flex-wrap gap-2">
            {(["Tümü", ...DURUM_LIST] as (GonderimDurumu | "Tümü")[]).map(d => (
              <button
                key={d}
                onClick={() => setDurumFilter(d)}
                className={`px-3 py-1.5 rounded-lg text-xs font-semibold cursor-pointer whitespace-nowrap transition-colors
                  ${durumFilter === d ? "bg-[#0B1120] text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`}
              >
                {d}
              </button>
            ))}
          </div>
          <div className="flex flex-col sm:flex-row gap-2 sm:ml-auto">
            {/* Tür filter */}
            <div className="relative">
              <select
                value={turFilter}
                onChange={e => setTurFilter(e.target.value)}
                className="pl-3 pr-8 py-2 text-xs border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 appearance-none bg-white cursor-pointer"
              >
                {TUR_LIST.map(t => <option key={t}>{t}</option>)}
              </select>
              <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 text-xs">
                <i className="ri-arrow-down-s-line"></i>
              </div>
            </div>
            {/* Search */}
            <div className="relative">
              <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-gray-400">
                <i className="ri-search-line text-sm"></i>
              </div>
              <input
                type="text"
                placeholder="İsim / telefon ara..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                className="w-full sm:w-52 pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366]"
              />
            </div>
          </div>
        </div>

        {/* Desktop */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-100">
                {["Veli Adı", "Öğrenci Adı", "Telefon", "Mesaj Türü", "Kampanya / Kural", "Durum", "Gönderim Zamanı", "Hata Bilgisi", "İşlem"].map(h => (
                  <th key={h} className="text-left text-[11px] font-semibold text-gray-400 px-4 py-3 whitespace-nowrap">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map(g => (
                <tr key={g.id} className="border-b border-gray-50 hover:bg-gray-50/50 transition-colors group">
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2.5">
                      <div className="w-7 h-7 rounded-full bg-[#0B1120]/10 flex items-center justify-center text-[#0B1120] text-xs font-bold flex-shrink-0">
                        {g.veliAdi.charAt(0)}
                      </div>
                      <span className="text-sm font-semibold text-gray-800 whitespace-nowrap">{g.veliAdi}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">{g.ogrenciAdi}</td>
                  <td className="px-4 py-3 text-xs text-gray-600 font-mono whitespace-nowrap">{g.telefon}</td>
                  <td className="px-4 py-3">
                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-lg whitespace-nowrap">{g.mesajTuru}</span>
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-600 max-w-[160px] truncate">{g.kampanyaKural}</td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold ${DURUM_STYLE[g.durum]}`}>
                      <i className={`${DURUM_ICON[g.durum]} text-xs`}></i>
                      {g.durum}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-500 whitespace-nowrap">
                    {g.gonderimZamani === "-" ? <span className="text-gray-300">Bekliyor</span> : g.gonderimZamani}
                  </td>
                  <td className="px-4 py-3 text-xs text-red-500 max-w-[130px] truncate">
                    {g.hataBilgisi || <span className="text-gray-300">—</span>}
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      <button
                        title="Yeniden Gönder"
                        className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#25D366]/10 text-[#25D366] hover:bg-[#25D366]/20 cursor-pointer transition-colors"
                      >
                        <i className="ri-refresh-line text-xs"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {filtered.length === 0 && (
            <div className="py-16 text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-gray-100 flex items-center justify-center mb-3">
                <i className="ri-send-plane-line text-gray-400 text-xl"></i>
              </div>
              <p className="text-sm text-gray-400">Bu filtreye uygun gönderim kaydı bulunamadı</p>
            </div>
          )}
        </div>

        {/* Mobile cards */}
        <div className="md:hidden divide-y divide-gray-100">
          {filtered.map(g => (
            <div key={g.id} className="p-4 space-y-2.5">
              <div className="flex items-start justify-between gap-2">
                <div>
                  <p className="text-sm font-bold text-gray-900">{g.veliAdi}</p>
                  <p className="text-xs text-gray-500">{g.ogrenciAdi} • {g.mesajTuru}</p>
                </div>
                <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold ${DURUM_STYLE[g.durum]}`}>
                  {g.durum}
                </span>
              </div>
              <p className="text-[11px] text-gray-500">{g.kampanyaKural}</p>
              <div className="flex items-center justify-between">
                <span className="text-xs font-mono text-gray-400">{g.telefon}</span>
                <span className="text-xs text-gray-400">{g.gonderimZamani === "-" ? "Bekliyor" : g.gonderimZamani}</span>
              </div>
              {g.hataBilgisi && <p className="text-xs text-red-500 bg-red-50 px-2 py-1 rounded-lg">{g.hataBilgisi}</p>}
            </div>
          ))}
        </div>

        <div className="px-4 py-3 border-t border-gray-100">
          <p className="text-xs text-gray-400">{filtered.length} kayıt gösteriliyor</p>
        </div>
      </div>
    </div>
  );
}